import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/trackinglog/list', qs.stringify(params))
}


//保存或修改数据
export const save = (params) => {
  if (params.unitguid) {
    return axios.post(root + '/set/trackinglog/update', qs.stringify(params))
  } else {
    return axios.post(root + '/set/trackinglog/save', qs.stringify(params))
  }
}

//删除数据
export const remove = (params) => {
  return axios.post(root + '/set/trackinglog/remove', qs.stringify(params))
}
//根据unitguid 获取数据
export const getDetail = (params) => {
  return axios.post(root + '/set/trackinglog/detail', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/trackinglog.js